export default "__VITE_ASSET__b7e6e07c__"